import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { CreateTenantBillingDto } from '../../billing/dtos/create-tenant-billing.dto';
import { PlatformContactDto } from '../../contacts/dtos/platform-contact.dto';
import { TenantStatusEnum } from '../enums/tenant-status.enum';

/**
 * Create tenant DTO
 */
export class CreateTenantDto {
  color?: string;
  /**
   * Lowered internal org id stored as `tenants.tenantId`.
   * Provisioning CRUD may send this with `tenantAuthProviderOrgId`; it must
   * match `toInternalTenantOrgId(tenantAuthProviderOrgId)`. Omitted → derived
   * from the issued id.
   */
  tenantOrgId?: string;
  /** Issued auth-provider organization id (`org_` + uppercase ULID). */
  tenantAuthProviderOrgId!: string;
  tenantName!: string;
  tenantDatabase!: string;
  email!: string;
  status!: TenantStatusEnum;
  contact!: PlatformContactDto;
  billing?: CreateTenantBillingDto;
  notes?: string;
  files?: FileDto[];
}
